import "../chunk-D57E6H3M.mjs";

// src/utils/shopifyImageSource.ts
var SHOPIFY_CDN_HOST = "cdn.shopify.com";
var STOREFRONT_CDN_PATH = "/cdn/shop/";
var PLACEHOLDER_ORIGIN = "https://placeholder.invalid";
var DENSITIES = [1, 2, 3];
function urlForm(url) {
  if (url.startsWith("//")) return "protocol-relative";
  return /^[a-z][a-z\d+.-]*:/i.test(url) ? "absolute" : "path";
}
function serialize(url, form) {
  if (form === "absolute") return url.href;
  if (form === "protocol-relative") return url.href.slice(url.protocol.length);
  return `${url.pathname}${url.search}${url.hash}`;
}
function shopifyImageSource(url, cssPx) {
  const form = urlForm(url);
  let parsed;
  try {
    parsed = new URL(url, PLACEHOLDER_ORIGIN);
  } catch {
    return { src: url };
  }
  const onShopifyCdn = form !== "path" && parsed.hostname === SHOPIFY_CDN_HOST;
  const onStorefrontCdn = (form !== "path" || url.startsWith("/")) && parsed.pathname.startsWith(STOREFRONT_CDN_PATH);
  const webScheme = parsed.protocol === "https:" || parsed.protocol === "http:";
  if (!webScheme || !(onShopifyCdn || onStorefrontCdn)) return { src: url };
  const atDensity = (density) => {
    const sized = new URL(parsed);
    sized.searchParams.set("width", String(Math.ceil(cssPx * density)));
    return serialize(sized, form);
  };
  return {
    src: atDensity(1),
    srcSet: DENSITIES.map((density) => `${atDensity(density)} ${density}x`).join(", ")
  };
}
export {
  shopifyImageSource
};
//# sourceMappingURL=shopifyImageSource.mjs.map